import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DELETE_MEDICATION_REQUEST, GET_DEFAULT_MEDICATIONS_REQUEST, GET_PATIENT_SCHEDULES_REQUEST } from '../../../../../redux/actions';
import classes from './Medications.module.scss';
import {AddEditMedicationModal, MedicationsTable} from './components';
import {Modal} from '../../../../common/Modal/Modal';
import {IMedication} from '../../../../../utils/interfaces';

export type SelectedMedicationData = {
  type: 'edit' | 'add' | 'remove' | null
  medication: IMedication | null
}

export const Medications = ({
  patientId,
}: {
  patientId: string;
}) => {
  const dispatch = useDispatch();

  const [selectedMedicationData, setSelectedMedicationData] = useState<SelectedMedicationData>({
    type: null,
    medication: null,
  })

  const closeModal = () => setSelectedMedicationData({type: null, medication: null});

  const deleteMedication = () => {
    if (selectedMedicationData.medication?.id) {
      dispatch({
        type: DELETE_MEDICATION_REQUEST,
        payload: {
          medicationId: selectedMedicationData.medication.id,
          patientId,
        }
      })
      closeModal()
      setTimeout(getPatientMedications, 300)
    }
  }

  const getPatientMedications = useCallback(() => {
    dispatch({
      type: GET_PATIENT_SCHEDULES_REQUEST,
      payload: {
        patientId,
      }
    })
  }, [dispatch, patientId]);

  useEffect(() => {
    getPatientMedications();
  }, [getPatientMedications])

  useEffect(() => {
    dispatch({
      type: GET_DEFAULT_MEDICATIONS_REQUEST,
    });
  }, [dispatch]);

  const onEditMedication = (medication: IMedication) => {
    setSelectedMedicationData({
      type: 'edit',
      medication,
    })
  }

  const onRemoveMedication = (medication: IMedication) => {
    setSelectedMedicationData({
      type: 'remove',
      medication,
    })
  }

  const onAddMedication = () => {
    setSelectedMedicationData({
      type: 'add',
      medication: null,
    })
  }

  return (
    <div className={classes.clickingOverviewContainer}>
      <MedicationsTable onEditMedication={onEditMedication} onRemoveMedication={onRemoveMedication} onAddMedication={onAddMedication} />
      <AddEditMedicationModal
        getPatientMedications={getPatientMedications}
        medication={selectedMedicationData.medication}
        onClose={closeModal}
        type={selectedMedicationData.type} />
      <Modal
        open={selectedMedicationData.type === 'remove'}
        title={"Delete medication"}
        message={
          "Are you sure that you want to delete this medication?"
        }
        handleCancel={closeModal}
        handleConfirm={deleteMedication}
      />
    </div>
  );
};
